import { motion } from 'motion/react'
import { enterVariants } from '../../lib/motion'

const STEPS = [
  { n: '01', title: 'Paste or upload', body: 'Text, Markdown or PDF. Up to 10MB.' },
  { n: '02', title: 'AI reads it', body: 'Action items, owners, deadlines and priorities.' },
  { n: '03', title: 'You review', body: 'Edit anything. Deselect what you do not want.' },
  { n: '04', title: 'Cards created', body: 'Straight into the board and list you pick.' },
]

export default function HowItWorks() {
  return (
    <section className="border-y border-white/[0.06] bg-surface-raised">
      <div className="mx-auto max-w-6xl px-4 py-20">
        <motion.ol
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ staggerChildren: 0.06 }}
          className="grid gap-10 md:grid-cols-4 md:gap-0"
        >
          {STEPS.map((step) => (
            <motion.li
              key={step.n}
              variants={enterVariants}
              className="md:border-l md:border-white/[0.06] md:px-6 md:first:pl-0"
            >
              <span className="font-mono text-caption text-primary-400">{step.n}</span>
              <h3 className="mt-3 text-h3 font-medium text-white">{step.title}</h3>
              <p className="mt-1.5 text-body text-white/50">{step.body}</p>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  )
}
